<script>
import resources from './resources'
import APP_URL from '@/plugins/http/appURL'

export default {
  name: 'gadget-staff',
  mixins: [resources],
  data: () => {
    return {
      mobileMenuOn: false,
      APP_URL: APP_URL
    }
  },
  methods: {
    goToTerms () {
      location.href = this.APP_URL + '/app/terms/term'
    },
    goToPolicy () {
      location.href = this.APP_URL + '/app/terms/policy'
    }
  }
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!")
    content-professional
    section#intro-professional.container-fluid(role='banner')
      .container
          .content.col-sm-6
            h1
              | O Medibook
              br
              | simplifica a saúde!
              br
              b Seja bem-vindo ao Medibook!
            .text.hidden-xs
              | Um sistema que facilita o agendamento de consultas médicas e permite que você possa focar seus esforços naquilo que você faz de melhor: as atividades médicas!
            //-a(href='#apresentacao')
              #know-more
                | Saiba Mais
                span.icon 
    section#highlight-prodfessional-video.container-fluid(role='contentinfo')
      .container
        .row
          .col-sm-12.col-md-5
            h2 Conheça o Medibook
            p
              | Seu consultório aberto 24 horas por dia.
          .col-sm-12.col-md-7.responsive-size
            div.border-shadow
              .embed-responsive.embed-responsive-16by9
                iframe.embed-responsive-item(
                  src='https://player.vimeo.com/video/287161148',
                  allowfullscreen=''
                )
        .clearfix

    section#apresentacao-professonal.container-fluid(role='definition')
      .container
        h2 Somos o melhor serviço de agendamento médico
        .row
          .col-xs-12.text.text-center.hidden-sm.hidden-md.hidden-lg(style='margin-bottom:30px;')
            | Seja bem-vindo ao Medibook! Um sistema que facilita o agendamento de consultas médicas e permite que você possa focar seus esforços naquilo que você faz de melhor: as atividades médicas!
        .row
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/01-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Gerencie suas agendas profissionais,
                |  com inúmeros endereços, horários flexíveis e intervalos personalizáveis de consultas.
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/02-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Crie você mesmo suas agendas
                |  ou delegue a atividade para outra pessoa de sua confiança
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/03-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Sistema simples, integrado e de fácil aprendizado
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/04-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Receba lembretes e notificações
                |  de agendamento através de mensagens SMS, aplicativo no seu celular ou por meio de um email
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/05-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Seja alertado sobre eventos agendados
                |  e receba prévias (resumidas ou detalhadas) dos seus próximos agendamentos;
          .col-sm-6.col-md-4
            .item
              .icon
                img(src='/static/images/icons/06-profissional.png')
              p(style="font-size: 14px;")
                b(style="font-size: 14px;") Tenha acesso a um serviço de retaguarda altamente qualificado
                | , pronto para orientar você ou sua equipe, dar todo o suporte técnico necessário e auxiliar desde os primeiros passos até o uso dos recursos mais avançados.
    section#highlight-prodfessional.container-fluid(role='contentinfo')
      .container
        .row
          .col-sm-12.col-md-5
            h2 Rápido, Fácil e Gratuito
            p
              | Sua agenda online em poucos minutos. Facilidade para você, praticidade para seus pacientes, tranquilidade para todos!
          .col-sm-12.col-md-7
            img(src='/static/images/profissional-computador.png')
        .clearfix
    section#contato-professional.container-fluid(role='contentinfo')
      .container
        .row
          .col-sm-6.col-sm-offset-1.col-md-5.left-col
            h2
              | Como podemos simplificar o processo de agendamento de consultas em seu ambiente profissional? Conte com a gente!
            h3
              | Conhecer a sua experiência nos levará
              br
              | ainda mais longe!
            p
              b Atendimento
              br
              |  Segunda à Sexta-feira das 09h00 às 18h00
            p
              b Telefone
              br
              a(href='tel:4135980860', style='color:inherit;text-decoration:none') 41 3598-0860
            p
              b E-mail
              br
              |contato@medibook.com.br
          .col-sm-5.col-md-4.medico
    footer#footer-professional.container-fluid
      #to-top(v-scroll-to="'#intro-professional'")
        svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='16.446px', height='7.71px', viewbox='0 0 16.446 7.71', overflow='scroll', enable-background='new 0 0 16.446 7.71', xml:space='preserve')
          defs
          g
            path(fill='#FFFFFF', d='M15.723,7.71c-0.186,0-0.37-0.071-0.512-0.212L9.757,2.044c-0.814-0.817-2.253-0.815-3.067,0L1.234,7.498\
            c-0.282,0.281-0.74,0.281-1.022,0c-0.283-0.283-0.283-0.741,0-1.023l5.455-5.454c1.36-1.36,3.752-1.361,5.113,0l5.454,5.454\
            c0.282,0.283,0.282,0.74,0,1.023C16.093,7.639,15.908,7.71,15.723,7.71z')
      .container
        .row
          .col-sm-10.col-sm-offset-1.col-md-3
            img.logo(src='/static/images/logo.svg')
            p
              | Medibook® é um serviço de agendamento de consultas e eventos de saúde, criado para atender as demandas de saúde existentes e facilitar o acesso à medicina de forma simples e eficiente. Trata-se de um serviço gratuito, sem custo para usuários e profissionais de saúde.
          .col-sm-10.col-sm-offset-1.col-md-2
            .title Mapa do Site
            ul
              a(href='#apresentacao')
                li Apresentação
              a(href='#contato')
                li Contato
              a.cursor-pointer(@click.prevent="goToTerms()", target="_blank")
                li Termos de Uso
              a.cursor-pointer(@click.prevent="goToPolicy()", target="_blank")
                li Políticas de Privacidade
          .col-sm-10.col-sm-offset-1.col-md-3
            .title Contato
            .phone
              a(href='tel:4135980860', style='color:inherit;text-decoration:none') 41 3598-0860
            .email contato@medibook.com.br
            .social
                a(href='')
                 .icon.facebook
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='8.842px', height='18.446px', viewbox='0 0 8.842 18.446', overflow='scroll', enable-background='new 0 0 8.842 18.446', xml:space='preserve')
                      defs
                      path(fill='#2071B6', d='M8.842,3.097c-0.575,0-1.128-0.005-1.68,0.003C6.936,3.103,6.708,3.116,6.486,3.157\
                      C6.055,3.236,5.83,3.473,5.818,3.912C5.799,4.635,5.813,5.358,5.813,6.111c0.905,0,1.836,0,2.799,0\
                      C8.571,6.5,8.535,6.858,8.497,7.215C8.432,7.821,8.36,8.426,8.302,9.033c-0.015,0.156-0.072,0.2-0.225,0.198\
                      C7.396,9.224,6.715,9.228,6.034,9.228c-0.076,0-0.152,0-0.252,0c0,3.086,0,6.146,0,9.218c-1.396,0-2.768,0-4.166,0\
                      c0-3.069,0-6.129,0-9.218c-0.413,0-0.801,0-1.189,0C0,9.228,0,9.228,0,8.803c0-0.809,0-1.617,0-2.426c0-0.077,0-0.153,0-0.251\
                      c0.54,0,1.061,0,1.615,0c0-0.102-0.001-0.184,0-0.266C1.63,5.017,1.616,4.172,1.67,3.331c0.048-0.758,0.264-1.476,0.753-2.086\
                      C2.928,0.615,3.607,0.28,4.38,0.143c0.472-0.084,0.957-0.122,1.437-0.132c0.943-0.02,1.887-0.006,2.83-0.006\
                      c0.062,0,0.125,0.008,0.196,0.013C8.842,1.044,8.842,2.056,8.842,3.097z')
                a(href='')
                  .icon.twitter
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='17.446px', height='14.3px', viewbox='0 0 17.446 14.3', overflow='scroll', enable-background='new 0 0 17.446 14.3', xml:space='preserve')
                      defs
                      g
                        path(fill='#00C0F7', d='M0,12.769c1.918,0.104,3.632-0.377,5.15-1.555c-1.076-0.087-1.973-0.511-2.666-1.335\
                        C2.199,9.538,1.983,9.159,1.84,8.705c0.534,0.077,1.041,0.084,1.602-0.083C2.3,8.332,1.474,7.714,0.954,6.716\
                        C0.689,6.208,0.55,5.664,0.571,5.058c0.503,0.244,1.004,0.411,1.578,0.428c-1.604-1.338-1.964-2.928-1.1-4.837\
                        c1.977,2.322,4.439,3.581,7.464,3.8c-0.02-0.181-0.036-0.337-0.055-0.492C8.24,2.175,9.542,0.402,11.312,0.073\
                        c1.248-0.232,2.34,0.084,3.261,0.96c0.1,0.095,0.191,0.095,0.306,0.068c0.666-0.155,1.3-0.394,1.9-0.723\
                        c0.05-0.028,0.102-0.051,0.188-0.094c-0.288,0.829-0.783,1.45-1.473,1.935c0.669-0.046,1.294-0.241,1.906-0.493\
                        c0.015,0.018,0.031,0.036,0.046,0.054c-0.345,0.386-0.681,0.779-1.038,1.153c-0.183,0.192-0.399,0.355-0.611,0.517\
                        c-0.102,0.078-0.131,0.158-0.132,0.285c-0.009,3.477-1.321,6.346-4.047,8.524c-1.408,1.125-3.044,1.742-4.833,1.956\
                        c-2.355,0.282-4.567-0.134-6.621-1.337C0.108,12.846,0.055,12.806,0,12.769z')
        .row
          .hidden-xs.col-sm-10.col-sm-offset-1.copyright
            .pull-left Medibook® - 2018 - Todos os direitos reservados.
            .pull-right
              | 80030-030 Curitiba - PR -&nbsp;
              a(href='tel:4135980860', style='color:inherit;text-decoration:none;display:inline-block') 41 3598-0860

          .hidden-sm.hidden-lg.col-sm-10.col-sm-offset-1.copyright
            .span.text-center Medibook® - 2018 - Todos os direitos reservados. 80030-030 Curitiba - PR -&nbsp;
              a(href='tel:4135980860', style='color:inherit;text-decoration:none;display:inline-block') 41 3598-0860
</template>
<style scoped>
  /* Highlight */

  #highlight-prodfessional-video {
      background: #f7f7f7;
      padding-top: 50px;
      padding-bottom: 90px;
      position: relative;
      z-index: 1;
      overflow: hidden;
      height: 400px;
  }

  #highlight-prodfessional-video:after {
      content: '';
      position: absolute;
      background: #ea1a3c;
      background: -webkit-gradient(linear, left top, right bottom, from(#ea1a3c), to(#c61436));
      background: linear-gradient(to bottom right, #ea1a3c, #c61436);
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0;
      z-index: -1;
  }

  #highlight-prodfessional-video h2 {
      font-size: 38px;
      font-weight: 300;
      color: #ffffff;
      position: relative;
      margin-bottom: 30px;
  }

  #highlight-prodfessional-video h2:after {
      content: "";
      position: absolute;
      width: 30px;
      height: 2px;
      background: #ffffff;
      left: 0px;
      bottom: -15px;
  }

  #highlight-prodfessional-video p {
      color: #ffffff;
      font-size: 20px;
      font-weight: 300;
  }

  #highlight-prodfessional-video img {
      max-width: 110%;
      position: relative;
      margin-top: -100px;
      image-rendering: crisp-edges;
  }

  /* Video */
  #video {
      background: #f7f7f7;
      padding-top: 55px;
      padding-bottom: 60px;
      position: relative;
      z-index: 1;
      overflow: hidden;
      height: 440px;
  }

  #video:after {
      content: '';
      position: absolute;
      background: #2080cd;
      background: -webkit-gradient(linear, left top, right bottom, from(#2080cd), to(#164ac4));
      background: linear-gradient(to bottom right, #2080cd, #164ac4);
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0;
      z-index: -1;
  }

  #video h2 {
      font-size: 38px;
      font-weight: 300;
      color: #ffffff;
      position: relative;
      margin-bottom: 30px;
  }

  #video h2 strong {
      font-weight: 400;
  }

  #video h2:after {
      content: "";
      position: absolute;
      width: 30px;
      height: 2px;
      background: #ffffff;
      left: 0px;
      bottom: -15px;
  }

  #video p {
      color: #ffffff;
      font-size: 20px;
      font-weight: 300;
  }

  #video img {
      max-width: 110%;
      position: relative;
      margin-top: -100px;
      image-rendering: crisp-edges;
  }
  .responsive-size {
    width: 49.333333%
  }
  .border-shadow {
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
    box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/loading-page/gadget/index.vue